module.exports = require("./ru-RU.js");